export default [
  {
    path: '',
    name: 'merchants',
    component: () => import(/* webpackChunkName: "merchants-stores" */ '~/views/MerchantsStores/MerchantsStores.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderMerchants' },
    },
  },

  {
    path: 'products',
    name: 'merchants-products',
    component: () => import(/* webpackChunkName: "merchants-products" */ '~/views/MerchantsProducts/MerchantsProducts.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderMerchants' },
      rootRouteName: 'merchants',
    },
  },

  {
    path: 'invoices',
    name: 'merchants-invoices',
    component: () => import(/* webpackChunkName: "merchants-invoices" */ '~/views/MerchantsInvoices/MerchantsInvoices.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderMerchants' },
      rootRouteName: 'merchants',
    },
  },

  {
    path: 'fees',
    name: 'merchants-fees',
    component: () => import(/* webpackChunkName: "merchants-fees" */ '~/views/MerchantsFees/MerchantsFees.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderMerchants' },
      rootRouteName: 'merchants',
    },
  },
];
